import React from "react";
import logo from "../../assets/logo.png";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { logoutApi } from "../../api/auth";
import { removeAllCookies } from "../../utils/utils";

class MyNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleSignOut = this.handleSignOut.bind(this);
  }

  handleSignOut() {
    logoutApi();

    const { cookies } = this.props;

    removeAllCookies();
    cookies.remove("fbsr_" + process.env.REACT_APP_FB_APP_ID, { path: "/" });
    cookies.remove("fbsr_" + process.env.REACT_APP_FB_APP_ID);
    cookies.remove("fbm_" + process.env.REACT_APP_FB_APP_ID, { path: "/" });
    cookies.remove("fbm_" + process.env.REACT_APP_FB_APP_ID);
    cookies.remove("id", { path: "/" });
    cookies.remove("fb_uid", { path: "/" });
    cookies.remove("role", { path: "/" });
  }

  render() {
    const fbAvatar = `https://graph.facebook.com/${
      this.props.fbUid
    }/picture?type=square`;

    let bg;

    if (process.env.REACT_APP_REGION === "STAGING") {
      bg = "dark justify-content-between";
    } else if (process.env.REACT_APP_REGION === "JP") {
      bg = "justify-content-between";
    } else {
      bg = "info justify-content-between";
    }

    return (
      <Navbar bg={bg} style={{ backgroundColor: "#fbd947" }}>
        <Navbar.Brand href={process.env.REACT_APP_URL_ROOT}>
          <img
            src={logo}
            className="d-inline-block align-top"
            alt="Kono logo"
          />
        </Navbar.Brand>

        {this.props.isAuthed && (
          <div>
            <Button variant="dark" size="sm" onClick={this.handleSignOut}>
              logout
            </Button>
            <Image src={fbAvatar} alt="avatar" roundedCircle />
          </div>
        )}
      </Navbar>
    );
  }
}

export default MyNavBar;
